/* Kit-Bundle: Multi-Add für Garn-Komponenten (Dawn) */
(function () {
  const form = document.querySelector('#product-form-kit');
  if (!form) return;

  const variantsDataEl = document.getElementById('kit-variants-json');
  const variants = variantsDataEl ? JSON.parse(variantsDataEl.textContent) : [];
  const componentsRoot = document.getElementById('kit-components');
  const totalEl = document.getElementById('kit-total');
  const errorEl = document.getElementById('kit-error');
  const addBtn = document.getElementById('add-kit');

  const money = (cents) =>
    (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });

  const getSelectedSizeLabel = () => {
    const vidStr = (form.querySelector('[name="id"]') || {}).value;
    if (!vidStr) return null;
    const vid = parseInt(vidStr, 10);
    const v = variants.find((x) => x.id === vid);
    return v ? v.option1 : null;
  };

  const getFormQty = () => {
    const q = form.querySelector('#kit-qty');
    const n = parseInt(q && q.value ? q.value : '1', 10);
    return Number.isFinite(n) && n > 0 ? n : 1;
  };

  const calcTotal = () => {
    if (!componentsRoot) return;
    const size = getSelectedSizeLabel();
    if (!size) {
      totalEl && (totalEl.textContent = 'Gesamt: –');
      return;
    }
    let sumCents = 0;
componentsRoot.querySelectorAll('.kit-component:not([hidden])').forEach((node) => {      const sel = node.querySelector('select.kit-select');
      const opt = sel && sel.selectedOptions && sel.selectedOptions[0];
      if (!opt || !opt.value) return;
      const perSizeQtyMap = node.dataset.perSizeQty ? JSON.parse(node.dataset.perSizeQty) : {};
      const needed = perSizeQtyMap[size] || 0;
      const priceCents = parseInt(opt.dataset.price || '0', 10);
      sumCents += priceCents * needed;
    });
    sumCents = sumCents * getFormQty();
    totalEl && (totalEl.textContent = `Gesamt: ${money(sumCents)}`);
  };

  const showError = (msg) => {
    if (!errorEl) return;
    errorEl.textContent = msg || '';
    if (msg) errorEl.focus?.();
  };

  // Toast Notification
  let toastEl = document.getElementById('kit-toast');
  if (!toastEl) {
    toastEl = document.createElement('div');
    toastEl.id = 'kit-toast';
    Object.assign(toastEl.style, {
      display: 'none',
      position: 'fixed',
      bottom: '32px',
      left: '50%',
      transform: 'translateX(-50%)',
      background: '#7f1d1d',
      color: '#fff',
      padding: '18px 28px',
      borderRadius: '12px',
      fontSize: '17px',
      fontWeight: '600',
      lineHeight: '1.45',
      maxWidth: '460px',
      width: '90%',
      textAlign: 'center',
      zIndex: '9999',
      boxShadow: '0 8px 32px rgba(0,0,0,0.22)',
      transition: 'opacity 0.3s'
    });
    document.body.appendChild(toastEl);
  }

  let toastTimer;
  const showToast = (msg) => {
    toastEl.textContent = msg;
    toastEl.style.display = 'block';
    toastEl.style.opacity = '1';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      toastEl.style.opacity = '0';
      setTimeout(() => { toastEl.style.display = 'none'; }, 300);
    }, 6000);
  };

  // Prüft ob eine Variante per API verfügbar ist
  const checkAvailable = async (variantId) => {
    try {
      const res = await fetch(`/variants/${variantId}.js`);
      if (!res.ok) return true; // Im Zweifel durchlassen
      const data = await res.json();
      return data.available === true;
    } catch {
      return true; // Im Zweifel durchlassen
    }
  };

  form.addEventListener('change', (e) => {
if (e.target.matches('#kit-size, .kit-select, #kit-qty, #kit-yarn-choice')) calcTotal();  });
  calcTotal();

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    showError('');

    const size = getSelectedSizeLabel();
    if (!size) {
      showError('Bitte zuerst eine Größe wählen.');
      form.querySelector('#kit-size')?.focus();
      return;
    }

    const components = componentsRoot
? Array.from(componentsRoot.querySelectorAll('.kit-component:not([hidden])'))      : [];

    const qtyMult = getFormQty();
    const kitTitle =
      document.querySelector('.product__title')?.textContent?.trim() || 'Strickpaket';

    addBtn && (addBtn.disabled = true);
    addBtn && (addBtn.textContent = 'Wird geprüft…');

    // Schritt 1: Alle Komponenten auf Verfügbarkeit prüfen bevor etwas zum Warenkorb hinzugefügt wird
    for (const node of components) {
      const title = node.dataset.title || 'Garn';
      const productHandle = node.dataset.productHandle || '';
      const isAnleitung = productHandle.includes('-anleitung');
      const sel = node.querySelector('select.kit-select');
      const opt = sel && sel.selectedOptions && sel.selectedOptions[0];

      // Farbe / Variante gewählt?
      if (!opt || !opt.value) {
        showError(`Bitte Farbe für „${title}" wählen.`);
        addBtn && (addBtn.disabled = false);
        addBtn && (addBtn.textContent = 'In den Warenkorb');
        sel?.focus();
        return;
      }

      const perSizeQtyMap = node.dataset.perSizeQty ? JSON.parse(node.dataset.perSizeQty) : {};
      const needed = (perSizeQtyMap[size] || 0) * qtyMult;

      if (!needed) {
        showError(`Für Größe ${size} ist keine Menge bei „${title}" hinterlegt.`);
        addBtn && (addBtn.disabled = false);
        addBtn && (addBtn.textContent = 'In den Warenkorb');
        return;
      }

      // Verfügbarkeit per API prüfen (available: true/false)
      const available = await checkAvailable(opt.value);

      if (!available) {
        if (isAnleitung) {
          showToast(
            'Die Anleitung ist leider gerade nicht verfügbar. Schau doch gern nach anderen Strickpaketen.'
          );
        } else {
          const colorName = opt.dataset.variantTitle || opt.textContent.trim();
          showToast(
            `Die Farbe „${colorName}" ist leider nicht mehr ausreichend verfügbar. Such dir gern eine andere Farbe aus.`
          );
        }
        addBtn && (addBtn.disabled = false);
        addBtn && (addBtn.textContent = 'In den Warenkorb');
        return;
      }
    }

    // Schritt 2: Alle Komponenten verfügbar – jetzt erst zum Warenkorb hinzufügen
    // Einzeln hinzufügen damit wir bei einem Fehler genau wissen welche Komponente betroffen ist
    for (const node of components) {
      const title = node.dataset.title || 'Garn';
      const productHandle = node.dataset.productHandle || '';
      const isAnleitung = productHandle.includes('-anleitung');
      const sel = node.querySelector('select.kit-select');
      const opt = sel && sel.selectedOptions && sel.selectedOptions[0];
      const colorName = opt.dataset.variantTitle || opt.textContent.trim();
      const perSizeQtyMap = node.dataset.perSizeQty ? JSON.parse(node.dataset.perSizeQty) : {};
      const needed = perSizeQtyMap[size] || 0;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'content-type': 'application/json', accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: parseInt(opt.value, 10),
              quantity: needed * qtyMult,
              properties: {
                Set: kitTitle,
                Komponente: title,
                Größe: size
              }
            }]
          })
        });

        if (!res.ok) {
          // Shopify meldet Bestandsproblem → Warenkorb leeren was wir gerade hinzugefügt haben
          // und Fehlermeldung zeigen
          await rollbackCart(kitTitle);

          if (isAnleitung) {
            showToast(
              'Die Anleitung ist leider gerade nicht verfügbar. Schau doch gern nach anderen Strickpaketen.'
            );
          } else {
            showToast(
              `Die Farbe „${colorName}" ist leider nicht in ausreichender Menge verfügbar. Such dir gern eine andere Farbe aus.`
            );
          }
          addBtn && (addBtn.disabled = false);
          addBtn && (addBtn.textContent = 'In den Warenkorb');
          return;
        }
      } catch (ex) {
        console.error(ex);
        showError('Fehler beim Hinzufügen. Bitte versuche es erneut.');
        addBtn && (addBtn.disabled = false);
        addBtn && (addBtn.textContent = 'In den Warenkorb');
        return;
      }
    }

    // Alles erfolgreich hinzugefügt
    if (customElements?.get('cart-drawer')) {
      document.body.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } else {
      window.location.href = '/cart';
    }

    addBtn && (addBtn.disabled = false);
    addBtn && (addBtn.textContent = 'In den Warenkorb');
  });

  // Rollback: bereits hinzugefügte Kit-Artikel aus dem Warenkorb entfernen
  const rollbackCart = async (kitTitle) => {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const updates = {};
      cart.items.forEach((item) => {
        if (item.properties && item.properties['Set'] === kitTitle) {
          updates[item.key] = 0;
        }
      });
      if (Object.keys(updates).length > 0) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({ updates })
        });
      }
    } catch (ex) {
      console.error('Rollback fehlgeschlagen:', ex);
    }
  };
})();